import { render, staticRenderFns } from "./open-data.vue?vue&type=template&id=718dc06a"
import script from "./open-data.vue?vue&type=script&lang=js"
export * from "./open-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports